import { BuildInfo } from 'ng-upgrade-basis';

const env = {
  isApp: null,
  build: new BuildInfo(),
  variables: null,
  apiRoot: '/api',
  production: null,
  hmr: null
};
env.build.project = 'demo';
env.build.part = 'rep';
env.build.deployment = 'local';
env.variables = {
  corpId: 'wx400acd664197d6b9',
  mapApiKey: 'ee95e52bf08006f63fd29bcfbcf21df0'
};

export const buildDefaultEnvironment = () => env;

